module.exports = __webpack_public_path__ + "static/media/event-1.3f37ea1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/event-1.jpg
// module id = 120
// module chunks = 1